<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="ok"
  >
    <v-card v-if="item">
      <v-card-title>{{ item.name }}</v-card-title>
      <v-card-text>{{ item.description }}</v-card-text>
      <v-card-actions>
        <v-btn id="singleButton" text @click.stop="ok" color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ItemDialog",
  data() {
    return {
      dialog: false,
      item: null,
      options: {
        width: 600,
        zIndex: 200,
      }
    };
  },

  methods: {
    open(item, options) {
      this.dialog = true;
      this.item = item;
      this.options = Object.assign(this.options, options);
    },
    ok() {
      this.dialog = false;
    },
  }
};
</script>